export default __webpack_public_path__ + "static/media/logo.250426d9.jpg";